import axios, {AxiosResponse} from 'axios'

export const createGuestUser = async (storeId:string):Promise<AxiosResponse<any>> => {
  try {
    const response = await axios.get(`/webapp/wcs/stores/servlet/CreateGuestUser?storeId=${storeId}`)
    const guestId = response.data?.userId
    if (guestId) {
      const userId = guestId.startsWith('G-') ? guestId.replace('G-', '') : guestId
      window.constants.ajaxParams.userId = userId
    } else {
      console.error('No userId in response, possible error:', response.data)
    }

    return response
  } catch (error) {
    console.error('error creating guest user:', error)
    throw error
  }
}
